module.exports = __webpack_public_path__ + "img/icon-msg.9915d2fe.svg";